import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import Link from '../../../common/components/Link';
import { MainLogo, Disclaimer } from './styled-components';
import mainLogo from '../../../../assets/images/logo-blue-gray.png';

const AuthFlow = ({ children }) => (
  <Fragment>
    <Row>
      <MainLogo src={mainLogo} alt="mainLogo" />
    </Row>
    {children}
    <Row center="xs">
      <Col xs={12}>
        <Disclaimer>
          By signing in, you agree to our <Link to="/tos">ToS</Link> and
          <Link to="/privacy-policy"> Privacy Policy</Link>
        </Disclaimer>
      </Col>
    </Row>
  </Fragment>
);

AuthFlow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default AuthFlow;



// WEBPACK FOOTER //
// ./src/views/officials-connect/layouts/AuthFlow/index.jsx